import { DatePicker } from '@mui/x-date-pickers';
import { styled } from '../../base-components';

export const StyledDatePicker = styled(DatePicker)(({ theme }) => {
    return {
        marginTop: theme.spacing(2.5),
        marginBottom: theme.spacing(0.5),
        '&.MuiFormHelperText-root': {
            position: 'absolute',
            top: '100%',
        },
        '.Mui-error': {
            '&.MuiFormHelperText-root': {
                position: 'absolute',
                top: '100%',
                marginTop: '0px',
                marginInlineStart: theme.spacing(1),
            },
        },
    };
});
